import { render, staticRenderFns } from "./3.vue?vue&type=template&id=bdd25fc4&scoped=true&"
import script from "./3.vue?vue&type=script&lang=js&"
export * from "./3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd25fc4",
  null
  
)

export default component.exports